var Helpers = (function () {
    function Helpers() {
    }
    Helpers.debounce = function (fn, delay) {
        var timer = null;
        delay = delay || 300;
        return function () {
            var context = this;
            var args = arguments;
            clearTimeout(timer);
            timer = setTimeout(function () {
                fn.apply(context, args);
            }, delay);
        };
    };
    Helpers.scopedLoop = function (list, fn, context) {
        for (var i = 0, len = list.length; i < len; i++) {
            (function (i) {
                fn(list[i], i, context);
            }).call(this, i);
        }
    };
    Helpers.createCustomEventForDispatch = function (eventName, data) {
        if (data === void 0) { data = {}; }
        var event;
        if (window.CustomEvent && typeof window.CustomEvent === 'function') {
            event = new CustomEvent(eventName, { detail: data });
        }
        else {
            event = document.createEvent('CustomEvent');
            event.initCustomEvent(eventName, true, true, data);
        }
        return event;
    };
    Helpers.isLegacyIE = function () {
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf('MSIE ');
        var trident = ua.indexOf('Trident/');
        var edge = ua.indexOf('Edge');
        return (msie > 0 || trident > 0 || edge > 0);
    };
    Helpers.serialize = function (form, makeArray) {
        if (makeArray === void 0) { makeArray = false; }
        var serialized = [];
        var elements = form.querySelectorAll('input,select,textarea');
        for (var i = 0; i < elements.length; i++) {
            var field = elements[i];
            if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') {
                continue;
            }
            if (field.type === 'select-multiple') {
                for (var j = 0; j < field.options.length; j++) {
                    if (!field.options[j].selected)
                        continue;
                    if (makeArray) {
                        serialized.push({
                            name: encodeURIComponent(field.name),
                            value: encodeURIComponent(field.options[j].value)
                        });
                    }
                    else {
                        serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.options[j].value));
                    }
                }
            }
            else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
                if (makeArray) {
                    serialized.push({
                        name: encodeURIComponent(field.name),
                        value: encodeURIComponent(field.value)
                    });
                }
                else {
                    serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value));
                }
            }
        }
        if (makeArray) {
            return serialized;
        }
        return serialized.join('&');
    };
    Helpers.getKeypressed = function (e) {
        var key = e.key;
        if (key !== undefined) {
            return key;
        }
        var keyCode = e.keyCode;
        if (keyCode !== undefined) {
            return keyCode;
        }
    };
    Helpers.readCookie = function (name) {
        var t = document.cookie;
        var i = t.indexOf(" " + name + "=");
        var r;
        return i === -1 && (i = t.indexOf(name + "=")), i == -1 ? t = null : (i = t.indexOf("=", i) + 1, r = t.indexOf(";", i), r == -1 && (r = t.length), t = unescape(t.substring(i, r))), t;
    };
    Helpers.createCookie = function (name, content, expiry) {
        var r = new Date;
        var u = '';
        r.setDate(r.getDate() + expiry);
        u = escape(content) + (expiry === null ? "" : ";  expires=" + r.toUTCString() + ";path=/");
        document.cookie = name + "=" + u;
    };
    Helpers.removeElement = function (element) {
        if (element) {
            element.parentNode.removeChild(element);
        }
    };
    Helpers.wrapElement = function (element, wrapper) {
        var parent = element.parentNode;
        var previousSibling = element.previousSibling;
        wrapper.appendChild(element);
        var nextSibling = previousSibling ? previousSibling.nextSibling : parent.firstChild;
        parent.insertBefore(wrapper, nextSibling);
        return wrapper;
    };
    Helpers.createGuid = function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    };
    Helpers.scrollToElement = function (element, behavior, delay, offsetAdjustment) {
        if (behavior === void 0) { behavior = 'smooth'; }
        if (delay === void 0) { delay = 0; }
        if (offsetAdjustment === void 0) { offsetAdjustment = 0; }
        var header = document.querySelector('[data-header]');
        var offset = header ? (header.offsetHeight + offsetAdjustment) : 0;
        setTimeout(function () {
            var position = element.getBoundingClientRect().top + window.pageYOffset - offset;
            window.scroll({ top: position, left: 0, behavior: behavior });
        }, delay);
    };
    return Helpers;
}());
new Helpers();
window.Helpers = Helpers;
